import dayjs from "dayjs"
import ExcelJS from "exceljs"
import saveAs from "file-saver"

export const statisticSplitCurrExcel = async (panel, year, isAuthorizedOfficer) => {
  const common_format = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  }

  const middle_center = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  }

  const middle_left_no_wrap = {
    vertical: "middle",
    horizontal: "left"
  }

  // const middle_left = {
  //   vertical: "middle",
  //   horizontal: "left",
  //   wrapText: true
  // }

  const middle_right = {
    vertical: "middle",
    horizontal: "right",
    wrapText: true
  }

  const workbook = new ExcelJS.Workbook()
  workbook.creator = "Registrar KMITL"
  workbook.created = new Date()

  panel.map((value) => {
    const worksheet = workbook.addWorksheet(value.OFFICIAL_FACULTY_ID, {
      pageSetup: { paperSize: 'A4', showGridLines: false },
      views: [{ state: "frozen", ySplit: 4 }],
    })

    worksheet.headerFooter.oddFooter = "หน้า &P จาก &N"

    let rowNum = 1
    let columnNum = 1

    // เริ่มวาดหัวข้อ-------------------------------------------------
    worksheet.mergeCells(`A${rowNum}:Y${rowNum}`)
    worksheet.getCell(`A${rowNum}`).alignment = middle_center
    worksheet.getCell(`A${rowNum++}`).value = `ข้อมูลจำนวนนักศึกษาทั้งหมดแยกตาม ระดับ คณะ สาขาวิชา/หลักสูตร แขนง แผนการเรียน ประเภทรับเข้า ชั้นปี และเพศ`

    worksheet.mergeCells(`A${rowNum}:Y${rowNum}`)
    worksheet.getCell(`A${rowNum}`).alignment = middle_center
    worksheet.getCell(`A${rowNum++}`).value = `${value.FACULTY_NAME_TH} ปีการศึกษา ${year}`

    // เริ่มวาดข้อมูลหัวตาราง-------------------------------------------------
    worksheet.getColumn(columnNum).width = 12
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "ระดับ"
    worksheet.mergeCells(`A3:A4`)

    worksheet.getColumn(columnNum).width = 60
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "สาขาวิชา/หลักสูตร"
    worksheet.mergeCells(`B3:B4`)

    worksheet.getColumn(columnNum).width = 25
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "แขนง"
    worksheet.mergeCells(`C3:C4`)

    worksheet.getColumn(columnNum).width = 10
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "แผนการเรียน"
    worksheet.mergeCells(`D3:D4`)

    worksheet.getColumn(columnNum).width = 15
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "ประเภทรับเข้า"
    worksheet.mergeCells(`E3:E4`)

    worksheet.getColumn(columnNum).width = 9
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "ระยะเวลาหลักสูตร"
    worksheet.mergeCells(`F3:F4`)

    for (let i = 1; i <= 8; i++) {
      let text = ""
      if (i == 7) text = "ตกค้าง"
      else if (i == 8) text = "สำเร็จการศึกษา"
      else text = `ปี ${i}`

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum).value = `${text}`
      worksheet.mergeCells(rowNum, columnNum, rowNum, columnNum + 1)

      worksheet.getColumn(columnNum).width = 6
      worksheet.getRow(rowNum + 1).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum + 1).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum + 1).getCell(columnNum++).value = `ชาย`

      worksheet.getColumn(columnNum).width = 6
      worksheet.getRow(rowNum + 1).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum + 1).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum + 1).getCell(columnNum++).value = `หญิง`
    }

    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum).value = `รวม`
    worksheet.mergeCells(rowNum, columnNum, rowNum, columnNum + 1)

    worksheet.getColumn(columnNum).width = 6
    worksheet.getRow(rowNum + 1).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum + 1).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum + 1).getCell(columnNum++).value = `ชาย`

    worksheet.getColumn(columnNum).width = 6
    worksheet.getRow(rowNum + 1).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum + 1).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum + 1).getCell(columnNum++).value = `หญิง`

    worksheet.getColumn(columnNum).width = 8
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "รวมทั้งหมด"
    worksheet.mergeCells(`Y3:Y4`)

    if (isAuthorizedOfficer) {
      worksheet.getColumn(columnNum).width = 8
      worksheet.getRow(rowNum + 1).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum + 1).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum + 1).getCell(columnNum++).value = `ลาออก`

      worksheet.getColumn(columnNum).width = 8
      worksheet.getRow(rowNum + 1).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum + 1).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum + 1).getCell(columnNum++).value = `พ้นสภาพ`
    }

    rowNum = 5
    columnNum = 1
    value.data.map((data) => {
      // เริ่มวาดข้อมูล-------------------------------------------------
      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.LEVEL_NAME_TH

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.CURRICULUM_NAME_TH

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.BRANCH_NAME_TH

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.STUDY_PLAN_NAME_TH

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.ADMIT_ROUND_NAME_TH

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.PERIOD)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS1_MALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS1_FEMALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS2_MALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS2_FEMALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS3_MALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS3_FEMALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS4_MALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS4_FEMALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS5_MALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS5_FEMALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS6_MALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASS6_FEMALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASSX_MALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.CLASSX_FEMALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.GRAD_MALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.GRAD_FEMALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.SUM_MALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.SUM_FEMALE)

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = parseInt(data.SUM)

      if (isAuthorizedOfficer) {
        worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
        worksheet.getRow(rowNum).getCell(columnNum).border = common_format
        worksheet.getRow(rowNum).getCell(columnNum++).value = data.LEAVE ? parseInt(data.LEAVE) : '-'

        worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
        worksheet.getRow(rowNum).getCell(columnNum).border = common_format
        worksheet.getRow(rowNum).getCell(columnNum++).value = data.RETIRE ? parseInt(data.RETIRE) : '-'
      }

      rowNum++
      columnNum = 1
    })

    worksheet.mergeCells(`A${rowNum}:Y${rowNum}`)
    worksheet.getCell(`A${rowNum}`).alignment = middle_right
    const dateText = dayjs(value.created_at).locale('th').format('D MMM BBBB')
    worksheet.getCell(`A${rowNum++}`).value = `ข้อมูล ณ วันที่ ${dateText}`

  });

  const buffer = await workbook.xlsx.writeBuffer();
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  const fileExtension = ".xlsx"
  const blob = new Blob([buffer], { type: fileType })
  saveAs(blob, `statistic-split-curr-${year}` + fileExtension)
}

export const studentStudy = async (value, faculty_name, year, semester) => {

  const common_format = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  }

  const middle_center = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  }

  const middle_left_no_wrap = {
    vertical: "middle",
    horizontal: "left"
  }

  // const middle_left = {
  //   vertical: "middle",
  //   horizontal: "left",
  //   wrapText: true
  // }

  const middle_right = {
    vertical: "middle",
    horizontal: "right",
    wrapText: true
  }

  const workbook = new ExcelJS.Workbook()
  workbook.creator = "Registrar KMITL"
  workbook.created = new Date()


  const worksheet = workbook.addWorksheet(`นักศึกษาที่ไม่ได้ลงทะเบียน`, {
    pageSetup: { paperSize: 'A4', showGridLines: false },
    // views: [{ state: "frozen", ySplit: 4 }],
  })

  worksheet.headerFooter.oddFooter = "หน้า &P จาก &N"

  let rowNum = 1
  let columnNum = 1
  let pageNum = 1
  let pageAll = Math.ceil(value.length / 30);

  worksheet.getCell(`D${rowNum}`).alignment = middle_right
  worksheet.getCell(`D${rowNum++}`).value = `หน้า: ${pageNum}/${pageAll}`
  worksheet.mergeCells(`A${rowNum}:D${rowNum}`)
  worksheet.getCell(`A${rowNum}`).alignment = middle_center
  worksheet.getCell(`A${rowNum}`).font = { bold: true };
  worksheet.getCell(`A${rowNum++}`).value = `รายงานนักศึกษาที่ไม่ได้ลงทะเบียน`
  worksheet.mergeCells(`A${rowNum}:D${rowNum}`)
  worksheet.getCell(`A${rowNum}`).alignment = middle_center
  worksheet.getCell(`A${rowNum}`).font = { bold: true };
  worksheet.getCell(`A${rowNum++}`).value = `คณะ${faculty_name}`
  worksheet.mergeCells(`A${rowNum}:D${rowNum}`)
  worksheet.getCell(`A${rowNum}`).alignment = middle_center
  worksheet.getCell(`A${rowNum}`).font = { bold: true };
  worksheet.getCell(`A${rowNum++}`).value = `ประจำภาคการศึกษาที่ ${semester}/${year}`
  worksheet.mergeCells(`A${rowNum}:D${rowNum}`)
  worksheet.getCell(`A${rowNum}`).alignment = middle_center
  worksheet.getCell(`A${rowNum}`).font = { bold: true };
  const dateText = dayjs(value.created_at).locale('th').format('D MMMM BBBB')
  worksheet.getCell(`A${rowNum++}`).value = `วันที่ออกรายงาน ${dateText}`

  // เริ่มวาดข้อมูลหัวตาราง-------------------------------------------------
  worksheet.getColumn(columnNum).width = 6
  worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
  worksheet.getRow(rowNum).getCell(columnNum).border = common_format
  worksheet.getRow(rowNum).getCell(columnNum).font = { bold: true };
  worksheet.getRow(rowNum).getCell(columnNum++).value = "ลำดับ"

  worksheet.getColumn(columnNum).width = 10
  worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
  worksheet.getRow(rowNum).getCell(columnNum).border = common_format
  worksheet.getRow(rowNum).getCell(columnNum).font = { bold: true };
  worksheet.getRow(rowNum).getCell(columnNum++).value = "รหัสนักศึกษา"

  worksheet.getColumn(columnNum).width = 25
  worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
  worksheet.getRow(rowNum).getCell(columnNum).border = common_format
  worksheet.getRow(rowNum).getCell(columnNum).font = { bold: true };
  worksheet.getRow(rowNum).getCell(columnNum++).value = "ชื่อ-นามสกุล"


  worksheet.getColumn(columnNum).width = 45
  worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
  worksheet.getRow(rowNum).getCell(columnNum).border = common_format
  worksheet.getRow(rowNum).getCell(columnNum).font = { bold: true };
  worksheet.getRow(rowNum).getCell(columnNum++).value = "สาขาวิชา"

  rowNum = 7
  columnNum = 1
  
  value.map((data, index) => {

    var fullname = `${data.t_prename}${data.t_name} ${data.t_surname}`

    // เริ่มวาดข้อมูล-------------------------------------------------
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = index + 1

    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = data.student_id

    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = fullname

    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = data.curr2_tname

    rowNum++
    columnNum = 1

    if ((index + 1) % 30 === 0) {
        pageNum++
        rowNum++
        worksheet.getCell(`D${rowNum}`).alignment = middle_right
        worksheet.getCell(`D${rowNum++}`).value = `หน้า: ${pageNum}/${pageAll}`
        worksheet.mergeCells(`A${rowNum}:D${rowNum}`)
        worksheet.getCell(`A${rowNum}`).alignment = middle_center
        worksheet.getCell(`A${rowNum}`).font = { bold: true };
        worksheet.getCell(`A${rowNum++}`).value = `รายงานนักศึกษาที่ไม่ได้ลงทะเบียน`
        worksheet.mergeCells(`A${rowNum}:D${rowNum}`)
        worksheet.getCell(`A${rowNum}`).alignment = middle_center
        worksheet.getCell(`A${rowNum}`).font = { bold: true };
        worksheet.getCell(`A${rowNum++}`).value = `คณะ${faculty_name}`
        worksheet.mergeCells(`A${rowNum}:D${rowNum}`)
        worksheet.getCell(`A${rowNum}`).alignment = middle_center
        worksheet.getCell(`A${rowNum}`).font = { bold: true };
        worksheet.getCell(`A${rowNum++}`).value = `ประจำภาคการศึกษาที่ ${semester}/${year}`
        worksheet.mergeCells(`A${rowNum}:D${rowNum}`)
        worksheet.getCell(`A${rowNum}`).alignment = middle_center
        worksheet.getCell(`A${rowNum}`).font = { bold: true };
        const dateText = dayjs(value.created_at).locale('th').format('D MMMM BBBB')
        worksheet.getCell(`A${rowNum++}`).value = `วันที่ออกรายงาน ${dateText}`

        // เริ่มวาดข้อมูลหัวตาราง-------------------------------------------------
        worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
        worksheet.getRow(rowNum).getCell(columnNum).border = common_format
        worksheet.getRow(rowNum).getCell(columnNum).font = { bold: true };
        worksheet.getRow(rowNum).getCell(columnNum++).value = "ลำดับ"

        worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
        worksheet.getRow(rowNum).getCell(columnNum).border = common_format
        worksheet.getRow(rowNum).getCell(columnNum).font = { bold: true };
        worksheet.getRow(rowNum).getCell(columnNum++).value = "รหัสนักศึกษา"

        worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
        worksheet.getRow(rowNum).getCell(columnNum).border = common_format
        worksheet.getRow(rowNum).getCell(columnNum).font = { bold: true };
        worksheet.getRow(rowNum).getCell(columnNum++).value = "ชื่อ-นามสกุล"

        worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
        worksheet.getRow(rowNum).getCell(columnNum).border = common_format
        worksheet.getRow(rowNum).getCell(columnNum).font = { bold: true };
        worksheet.getRow(rowNum).getCell(columnNum++).value = "สาขาวิชา"

        rowNum ++
        columnNum = 1
    }
  })

  worksheet.mergeCells(`A${rowNum}:D${rowNum}`)
  worksheet.getCell(`A${rowNum}`).alignment = middle_center
  worksheet.getCell(`A${rowNum}`).font = { bold: true };
  worksheet.getCell(`A${rowNum++}`).value = `รวมจำนวนนักศึกษาที่ไม่ได้ลงทะเบียนเรียน ${value.length} คน`

  worksheet.eachRow((row) => {
  row.eachCell((cell) => {
    cell.font = {
      ...cell.font,      
      name: "Cordia New", 
      size: 12           
    };
  });
});

  const buffer = await workbook.xlsx.writeBuffer();
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  const fileExtension = ".xlsx"
  const blob = new Blob([buffer], { type: fileType })

  saveAs(blob, `นักศึกษาที่ไม่ได้ลงทะเบียน คณะ${faculty_name}` + fileExtension);
}